import { FunctionComponent, MouseEvent, useEffect, useState } from 'react'
import { NotificationService, NotificationType } from '@/services/notification/notification.service'
import { Notification } from '@medable/medable-web-ui'

const DEFAULT_TIMEOUT = 5000

export const NotificationWrapper: FunctionComponent = () => {
  const [params, setParams] = useState<NotificationType | undefined>()

  useEffect(() => {
    NotificationService.addListener(onNotify)
  }, [])

  /**
   * Automatically shows a notification with the provided parameters
   * It's automatically closed after the specified time
   */
  const onNotify = (notificationParams: NotificationType, timeout = DEFAULT_TIMEOUT) => {
    setParams(notificationParams)

    setTimeout(() => setParams(undefined), timeout)
  }

  const onClose = (event: MouseEvent) => {
    if (params && params.onDismiss) {
      params.onDismiss(event)
    }

    setParams(undefined)
  }

  if (!params) {
    return null
  }

  return (
    <Notification
      action={params.action}
      className={params.className}
      data-testid='notification'
      dismissable={params.dismissable}
      message={params.message}
      onDismiss={onClose}
      size={params.size}
      title={params.title}
      toast={params.toast}
      variant={params.variant}
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        right: '3rem',
        top: '3rem',
        width: '30%',
        zIndex: 10,
      }}
    />
  )
}
